export interface AbstractModel {
    id?: number;
    params?: string;
}
